import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {
  toggleLoading
} from "../../../redux";
import {IDealInfoRequest} from "../../models";
import {IDealCard} from "../../../shared/models";
import {Store} from "@ngrx/store";
import {DealService} from "../../services";
import {ToastrService} from "ngx-toastr";
import {HttpErrorResponse} from "@angular/common/http";
import {FormControl} from "@angular/forms";
import {forkJoin} from "rxjs";
import {UtilService} from "../../../shared/services";
import { DataService } from 'src/app/services/data/data.service';

@Component({
  selector: 'app-deal-edit',
  templateUrl: './deal-edit.component.html',
  styleUrls: ['./deal-edit.component.scss']
})
export class DealEditComponent implements OnInit {

  selected = new FormControl(0);

  dealInfo: IDealInfoRequest = {} as unknown as IDealInfoRequest;
  preNdaDeal?: IDealCard;
  postNdaDeal?: IDealCard;
  postClose?: IDealCard;

  @ViewChild('fileUpload') private fileInput: ElementRef | undefined;

  constructor(
    private store: Store,
    private dealService: DealService,
    private toastr: ToastrService,
    public util: UtilService,
    private dataService: DataService,
  ) {
  

  }

  ngOnInit(): void {
    // get deal info to display (moic, timeline, etc.)
    var dealId = this.dataService.getDealId();

    this.store.dispatch(toggleLoading({loading: true}));
    forkJoin([
      this.dealService.getDeal(dealId),
      this.dealService.getDealInformation(dealId)
    ]).subscribe({
      next: ([deal, dealInfo]) => {
        // console.log("Deal information", deal, dealInfo);

        var dealCard = deal as IDealCard;
        var di = dealInfo as IDealInfoRequest;


        this.preNdaDeal = <IDealCard> {
          id: dealCard.id,
          projectName: dealCard.projectName,
          assetName: "",
          oneLineTeaser: dealCard.oneLineTeaser,
          dealTimeline: dealCard.dealTimeline,
          dealCloseType: dealCard.dealCloseType,

          targetMoicBase: dealCard.targetMoicBase,
          expectedDuration: dealCard.expectedDuration,
          fundraiseSize: dealCard.fundraiseSize,

          description: di.preNdaDescription,
          dealImageUrl: di.preImageUrl
        };

        this.postNdaDeal = <IDealCard> {
          id: dealCard.id,
          projectName: dealCard.projectName,
          assetName: dealCard.assetName,
          oneLineTeaser: dealCard.oneLineTeaser,
          dealTimeline: dealCard.dealTimeline,
          dealCloseType: dealCard.dealCloseType,

          targetMoicBase: dealCard.targetMoicBase,
          expectedDuration: dealCard.expectedDuration,
          fundraiseSize: dealCard.fundraiseSize,

          description: di.postNdaDescription,
          dealImageUrl: di.postImageUrl
        };
        
        this.postClose = <IDealCard> {
          id: dealCard.id,
          projectName: dealCard.projectName,
          assetName: dealCard.assetName,
          oneLineTeaser: dealCard.oneLineTeaser,
          dealTimeline: dealCard.dealTimeline,
          dealCloseType: dealCard.dealCloseType,

          targetMoicBase: dealCard.targetMoicBase,
          expectedDuration: dealCard.expectedDuration,
          fundraiseSize: dealCard.fundraiseSize,

          description: di.postCloseDescription,
          dealImageUrl: di.closedImageUrl
        };

        this.dealInfo = dealInfo;

        this.store.dispatch(toggleLoading({loading: false}));
      }, error: (error: HttpErrorResponse) => {
        this.toastr.error("Unable to get deal information!", $localize`:@@companyName:Rondeivu`);
        this.store.dispatch(toggleLoading({loading: false}));
      },

    });


  }

  // private setFormObjects(di: IDealInfoRequest) {
  //   //pre nda card view
  //   this.preNdaDeal.dealImageUrl = di.preImageUrl;
  //   this.preNdaDeal.assetName = "";
  //   this.preNdaDeal.description = di.preNdaDescription;
  //   this.preNdaDeal.oneLineTeaser = di.oneLineTeaser;
  //   this.preNdaDeal.pills = [{
  //     name: "Pre-NDA",
  //     backgroundColor: "#E8EDF6",
  //     fontColor: "#002150",
  //     borderColor: "#E8EDF6",
  //     tooltip: "Example of the Pre-NDA Deal"
  //   }];

  //   // this.preNdaDeal.dealTimeline = {
  //   //   current: {tooltip: "Example of the Pre-NDA Deal", xPos: 0},
  //   //   markers: [{title: "Pending", titlePos: "top", xPos: 0, status: "CURRENT"}, {
  //   //     title: "Live",
  //   //     titlePos: "top",
  //   //     xPos: 50,
  //   //     status: "FUTURE"
  //   //   }, {title: "Closed", titlePos: "top", xPos: 100, status: "FUTURE"}]
  //   // }

  //   //post nda card view
  //   this.postNdaDeal.dealImageUrl = di.postImageUrl;
  //   this.postNdaDeal.assetName = di.assetName;
  //   this.postNdaDeal.description = di.postNdaDescription;
  //   this.postNdaDeal.pills = [{
  //     name: "Post-NDA",
  //     backgroundColor: "#002150",
  //     fontColor: "#E8EDF6",
  //     borderColor: "#002150",
  //     tooltip: "Example of the Post-NDA Deal"
  //   }];
  //   // this.postNdaDeal.dealTimeline = {
  //   //   current: {tooltip: "Example of the Post-NDA Deal", xPos: 50},
  //   //   markers: [{title: "Pending", titlePos: "top", xPos: 0, status: "PAST"}, {
  //   //     title: "Live",
  //   //     titlePos: "top",
  //   //     xPos: 50,
  //   //     status: "CURRENT"
  //   //   }, {title: "Closed", titlePos: "top", xPos: 100, status: "FUTURE"}]
  //   // }

  //   //post close card view
  //   this.postClose.dealImageUrl = di.closedImageUrl;
  //   this.postClose.assetName = di.assetName;
  //   this.postClose.description = di.postCloseDescription;
  //   this.postClose.pills = [{
  //     name: "Closed",
  //     backgroundColor: "#B71C1C",
  //     fontColor: "#FFEBE5",
  //     borderColor: "#B71C1C",
  //     tooltip: "Example of the Closed Deal"
  //   }];
  //   // this.postClose.dealTimeline = {
  //   //   current: {tooltip: "Example of the Post-Close Deal", xPos: 100},
  //   //   markers: [{title: "Pending", titlePos: "top", xPos: 0, status: "PAST"}, {
  //   //     title: "Live",
  //   //     titlePos: "top",
  //   //     xPos: 50,
  //   //     status: "PAST"
  //   //   }, {title: "Closed", titlePos: "top", xPos: 100, status: "CURRENT"}]
  //   // }

  //   console.log("Pre-NDA Deal", this.preNdaDeal);
  //   console.log("Post-NDA Deal", this.postNdaDeal);
  //   console.log("Post-Close Deal", this.postClose);
  // }

  changeTab(event: any) {
    this.selected.setValue(event);
  }

  /**
   * Action for adding a new file
   * @param event
   */
  addDocuments(event: any) {
    // console.log(event);
    if (!!event && !!event.target && !!event.target.files[0]) {
      this.uploadDealImg(event.target.files[0]);
      if (!!this.fileInput) {
        this.fileInput.nativeElement.value = '';
      }
    }
  }

  private uploadDealImg(file: any) {
    this.store.dispatch(toggleLoading({loading: true}));
    this.dealService.uploadDealImage(file, this.getType(), this.dealInfo.id).subscribe({
      next: (res: { url: string }) => {
        console.log(this.selected.value);
        switch (this.selected.value) {
          case 0:
            //pre nda card view
            setTimeout(() => {
              if (this.preNdaDeal) {
                this.preNdaDeal = { ...this.preNdaDeal, dealImageUrl: res.url };
              }
            });
            break;
          case 1:
            //post nda card view
            setTimeout(() => {
              if (this.postNdaDeal) {
                this.postNdaDeal = { ...this.postNdaDeal, dealImageUrl: res.url };
              }
            });
            break;
          case 2:
            //post close card view
            setTimeout(() => {
              if (this.postClose) {
                this.postClose = { ...this.postClose, dealImageUrl: res.url };
              }
            });
            break;
        }
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.success("Image Updated!", $localize`:@@companyName:Rondeivu`);
      }, error: (err: HttpErrorResponse) => {
        console.log(err);
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Unable to update deal image!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  saveDealInformation() {
    const allowedPattern = /^[a-zA-Z0-9 _-]*$/;
    var projectName = this.preNdaDeal?.projectName;
    if (!projectName) {
      this.toastr.error("Project Name cannot be empty");
      return;
    }

    if (allowedPattern.test(projectName) == false) {
      // has special characters
      this.toastr.error("Project Name cannot contain special characters");
      return;
    }
    
    this.store.dispatch(toggleLoading({loading: true}));
    this.dealService.updateDealInfo(this.getDealInfoRequest()).subscribe({
      next: (di: IDealInfoRequest) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.success("Deal Card Updated!", $localize`:@@companyName:Rondeivu`);
      }, error: (err: HttpErrorResponse) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Unable to update deal information!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  getDealInfoRequest(): IDealInfoRequest {
    if (this.preNdaDeal == null || this.postNdaDeal == null || this.postClose == null) {
      throw new Error("Deal information is incomplete");
    }

    return {
      id: this.dealInfo.id,
      projectName: this.preNdaDeal.projectName,
      preNdaDescription: this.preNdaDeal.description,
      assetName: this.postNdaDeal.assetName,
      oneLineTeaser: this.preNdaDeal.oneLineTeaser,
      postNdaDescription: this.postNdaDeal.description,
      preImageUrl: this.preNdaDeal.dealImageUrl,
      postImageUrl: this.postNdaDeal.dealImageUrl,
      closedImageUrl: this.postClose.dealImageUrl,
      postCloseDescription: this.postClose.description
    } as IDealInfoRequest;
  }

  changeProjectName(event: any) {
    setTimeout(() => {
       if (this.preNdaDeal == null || this.postNdaDeal == null || this.postClose == null) {
        throw new Error("Deal information is incomplete");
      }
      this.postNdaDeal.projectName = this.preNdaDeal.projectName;
      this.postClose.projectName = this.preNdaDeal.projectName;
    });
  }

  changeOneLineTeaser(event: any) {
    setTimeout(() => {
       if (this.preNdaDeal == null || this.postNdaDeal == null || this.postClose == null) {
        throw new Error("Deal information is incomplete");
      }
      this.postNdaDeal.oneLineTeaser = this.preNdaDeal.oneLineTeaser;
      this.postClose.oneLineTeaser = this.preNdaDeal.oneLineTeaser;
    });
  }

  /**
   * Get the display for the state
   */
  getStateTitle() {
    switch (this.selected.value) {
      case 0:
        return 'Pre-NDA';
      case 1:
        return 'Post-NDA';
      case 2:
        return 'Post-Close';
    }
    return 'Pre-NDA';
  }

  private getType() {
    switch (this.selected.value) {
      case 0:
        return 'pre';
      case 1:
        return 'post';
      case 2:
        return 'closed';
    }
    return '';
  }
}
